import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '../primitives/index.js';
const AmountInput = ({ value, setValue, ...inputProps }) => {
    return (_jsx(Input, { ...inputProps, type: "text", inputMode: "decimal", autoComplete: "off", autoCorrect: "off", pattern: "^[0-9]+(\\.[0-9]*)?$", ellipsify: true, size: "large", className: "ph-no-capture", css: {
            width: '100%',
            background: 'none',
            backgroundColor: 'transparent',
            fontWeight: '600',
            fontSize: 32,
            px: '0 !important',
            py: '1',
            _focus: {
                boxShadow: 'none',
                outline: 'none'
            },
            _placeholder: {
                color: 'gray12'
            },
            ...inputProps.css
        }, placeholder: inputProps.placeholder ?? '0', value: value, onChange: inputProps.onChange
            ? inputProps.onChange
            : (e) => {
                const inputValue = e.target.value;
                const regex = /^[0-9]+(\.[0-9]*)?$/;
                if (inputValue === '.' || inputValue.includes(',')) {
                    setValue('0.');
                }
                else if (regex.test(inputValue) || inputValue === '') {
                    setValue(inputValue);
                }
            } }));
};
export default AmountInput;
//# sourceMappingURL=AmountInput.js.map